import React from "react";
import { Routes, Route } from "react-router-dom";

import "./App.css";
import NotFound from "./pages/error/NotFound";
import Home from "./pages/home";
import LoadingMain from "./pages/main";
import PartnersPage from "./pages/partners";
import Home1 from "./pages/home/indexTry";

function App() {
  return (
    <div className="App">
      <Routes>
        <Route exact path="/" element={<LoadingMain />} />
        <Route exact path="/home" element={<Home />} />
        <Route exact path="/home1" element={<Home1 />} />
        <Route exact path="/partners" element={<PartnersPage />} />
        <Route path="*" element={<NotFound />} />
      </Routes>
    </div>
  );
}

export default App;
